import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppNavigation } from '@app/app.navigation';
import { AccountSnapshot } from '../states/account/account.snapshot';

@Injectable()
export class UnauthGuard {
  constructor(
    private router: Router,
    private accountSnapshot: AccountSnapshot,
  ) {}

  canLoad(): boolean {
    if (this.accountSnapshot.isAuthenticated) {
      this.router.navigate([AppNavigation.Dashboard]);
      return false;
    }

    return true;
  }
}
